import {useEffect, useState, useRef} from 'react';
import eyeClosed from '../../pics/icons/eyeClosed.png'; 
import eyeOpen from '../../pics/icons/eyeOpen.png'; 
import OptionButton from '../EncounterColumn/OptionButton';
import isPlayerImg from '../../pics/icons/isPlayerImg.png';
import isPetImg from '../../pics/icons/pet.PNG';
import FlagPole from './FlagWidget/FlagPole.js';
import EffectImg from '../../pics/icons/effectImg.png';
import { addSign, COLOR_GREEN, COLOR_RED} from '../../constants.js';
import EncounterListItemSmallStat from './EncounterListItemSmallStat.js';
import EditAvatar from '../Statblock/EditAvatar.js';
import WidgetPopUp from './WidgetPopUp.js';
import TeamWidgetPopup from './FlagWidget/TeamWidgetPopup.js';
import HpEditPopup from './ListItemHp/HpEditPopup.js';
import EffectGrids from './EffectGrids.js';

const colors = {
    0: "green",
    1: "orange",
    2: "brown",
}

const EncounterListItem = ({index, currentEncounter, creatureListItem, isTurn, setCurrentEncounter, handleUploadMonsterImage, selectedIndex, handleRemoveFromSelectedIndex, clickEncounterCreatureX, resort, quickEdit, effectDuration, setEffectDuration, conditionDuration, setConditionDuration, socket}) => {
    // Track previous index for animation direction
    const [prevIndex, setPrevIndex] = useState(index);
    const [moveDirection, setMoveDirection] = useState(null); // 'up' | 'down' | null
    const animationRef = useRef(null); 
    const [hpHist, setHpHist] = useState([])

    useEffect(() => {
        clearTimeout(animation.current)

        if (prevIndex !== index) {
            setMoveDirection(prevIndex > index ? 'up' : 'down');
        } else {
            setMoveDirection(null);
        }

        animationRef.current = setTimeout((() => {
            setMoveDirection(null)
        }), 2000)

        setPrevIndex(index);
    }, [index, creatureListItem.creatureGuid]);

    const scrollRef = useRef(null);
    const [hidden, setHidden] = useState(creatureListItem.hidden);
    const [creature, setCreature] = useState(creatureListItem)
    const [isHovered, setIsHovered] = useState(false);

    const [maxHp, setMaxHp] = useState(creatureListItem.hit_points);
    const [currentHp, setCurrentHp] = useState(creatureListItem.hit_points_current);

    const [openTeamWidget, setOpenTeamWidget] = useState(false);

    const [isPlayer, setIsPlayer] = useState(creature.type === "player");
    const [isPet, setIsPet] = useState(creature.alignment === "pet");
    const [showGroup, setShowGroup] = useState(creature.groupGuid ? creature.groupGuid[0] !== '!' : null);
    const [isDndB, setIsDndB] = useState(creature.dnd_b_player_id ? creature.dnd_b_player_id[0] !== "!" : null);
    const [alignment, setAlignment] = useState(creature.alignment);
    const [borderColor, setBorderColor] = useState(creature.border);
    const [effects, setEffects] = useState(creature.effectObjs || []);
    const [selected, setSelected] = useState(false)
    const [selectedPlace, setSelectedPlace] = useState(-1)
    const [shake, setShake] = useState(undefined);

    useEffect(() => {
        if(isTurn && scrollRef.current) {
            if(scrollRef.current) {
                scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'center'}); // 'smooth' for animated scroll, 'auto' for instant
            }
        }
    }, [isTurn]);

    useEffect(() => {
        if(creatureListItem.effectObjs) {
            const isSame = effects.length === creatureListItem.effectObjs.length &&
                effects.every((e, i) => e.effectName === creatureListItem.effectObjs[i].effectName &&
                    e.duration === creatureListItem.effectObjs[i].duration);
            
            if (!isSame) {
                setEffects(creatureListItem.effectObjs || []);
            }
        }
    }, [creatureListItem, creatureListItem.effectObjs]);

    useEffect(() => {
        if(shake) {
            setTimeout(() => {
                setShake(undefined)
            }, 1000)
        }
    }, [shake])

    useEffect(() => {
        const selectedIndexOf = selectedIndex.findIndex(obj => obj.index === index);
        setSelectedPlace(selectedIndexOf)
        setSelected(selectedIndexOf !== -1)
    }, [selectedIndex])

    useEffect(() => {
        setCreature(creatureListItem)
        // eslint-disable-next-line
    }, [creatureListItem, creatureListItem.initiative]);

    const handleCreatureChange = () => {
        setCurrentEncounter(prev => ({
            ...prev,
            creatures: [...prev.creatures.map((oldCreature) => {
                return oldCreature.creatureGuid === creature.creatureGuid ? creature : oldCreature;
            })]
        }));
    }

    // This useeffect is for checking changes from the statblock edit
    useEffect(() => {
        if(creatureListItem.hit_points !== creature.hit_points || creatureListItem.hit_points_current !== creature.hit_points_current) {
            setMaxHp(creatureListItem.hit_points)
            setCurrentHp(creatureListItem.hit_points_current)
        }
    // eslint-disable-next-line
    }, [creatureListItem.hit_points, creatureListItem.hit_points_current]);

    useEffect(() => {
        let newCreature = {
                ...creature, 
                alignment: alignment,
                type: isPlayer ? 'player' : 'monster',
                border: borderColor,
                hidden: hidden,
                groupGuid: creature.groupGuid,
                effectObjs: [...effects]
        }

        setCurrentEncounter(prev => ({
            ...prev,
            creatures: [...prev.creatures.map((oldCreature) => {
                return oldCreature.creatureGuid === newCreature.creatureGuid ? newCreature : oldCreature;
            })]
        }));
        
    // eslint-disable-next-line
    }, [alignment, isPlayer, isPet, showGroup, borderColor, hidden, effects]);

    const handleChangeName = (event, send = false) => {
        let newName = event.target.value
        if(creature.name !== newName) {
            setCreature({...creature, name: newName})
        }

        if(send) {
            socket.emit("creatureNameChange", newName, creature.creatureGuid, "dm")
            currentEncounter.creatures[index].name = newName
            resort()
        }
    }

    const handleInitiativeChange = (event) => {
        if(!isNaN(event.target.value)) {
            let init = parseInt(event.target.value)
            if(creature.initiative !== init) {
                creature.initiative = isNaN(init) ? "" : init       
                setCreature({...creature})
            }
        }
    }
    
    const handleInitiativeCheck = () => {
        let init = creature.initiative === "" ? 0 : creature.initiative
        socket.emit('creatureInitiativeChange', init, creature.creatureGuid, currentEncounter.encounterGuid, "dm");
        currentEncounter.creatures[index].initiative = init
        resort()
    }    
    
    const handleHideEnemy = (event) => {
        event.stopPropagation()
        socket.emit('creatureHiddenToggle', !hidden, creature.creatureGuid, "dm");
        setHidden(!hidden)
    }  
    
    const handleAlignmentChange = (team) => {
        // If the creature is a pet and the new team is 'neutral' or 'enemy'
        if (team === 'neutral' || team === 'enemy') {
            setIsPet(false); // Remove pet status
        }

        // Only allow ally click if its not a pet
        if ((!isPet && team === 'ally') || team === 'neutral' || team === 'enemy') {
            setAlignment(team);
            socket.emit('creatureAlignmentChange', team, creature.creatureGuid, "dm");
        }
    };

    const handleTeamColorChange = (newBorderColor) => {
        if(newBorderColor.hex !== borderColor) {
            setBorderColor(newBorderColor.hex)
            socket.emit('creatureBorderColorChange', newBorderColor.hex, creature.creatureGuid, "dm");
        }
    };

    const handleCheckboxChange = (event) => {
        let checked = event.target.checked
        setIsPlayer(checked);

        if(checked && creature.alignment === 'pet') {
            setIsPet(false)
            setAlignment('ally')
            socket.emit('creatureAlignmentChange', 'ally', creature.creatureGuid, "dm");
        }

        socket.emit('creatureIsPlayerChange', checked, creature.creatureGuid, "dm");
        handleCreatureChange()
    };

    const handleDndBCheckboxChange = (event) => {
        let checked = event.target.checked
        setIsDndB(checked);

        if(creature.dnd_b_player_id) {
            if(checked && creature.dnd_b_player_id[0] === '!') {
                creature.dnd_b_player_id = creature.dnd_b_player_id.slice(1)
            } else if(!checked && creature.dnd_b_player_id[0] !== '!'){
                creature.dnd_b_player_id = '!' + creature.dnd_b_player_id
            }
        }

        socket.emit('creatureDndBIdChange', creature.dnd_b_player_id, creature.creatureGuid, "dm");
        handleCreatureChange()
    };


    const handleGroupCheckboxChange = (event) => {
        let checked = event.target.checked
        setShowGroup(checked);

        if(creature.groupGuid) {
            if(checked && creature.groupGuid[0] === '!') {
                creature.groupGuid = creature.groupGuid.slice(1)
            } else if(!checked && creature.groupGuid[0] !== '!'){
                creature.groupGuid = '!' + creature.groupGuid
            }
        }

        socket.emit('creatureShowGroupChange', creature.groupGuid, creature.creatureGuid, "dm");
        handleCreatureChange()
    };

    const handlePetCheckboxChange = (event) => {
        let checked = event.target.checked
        let team = checked ? 'pet' : 'ally'

        setIsPet(checked);
        if(checked && isPlayer) {
            setIsPlayer(false)
            socket.emit('creatureIsPlayerChange', false, creature.creatureGuid, "dm");
        }

        setAlignment(team);
        socket.emit('creatureAlignmentChange', team, creature.creatureGuid, "dm");
    };

    const handleTeamChangeWidget = (openReturned) => {
        setOpenTeamWidget(openReturned)
    }

    const handleArmorClassChange = (event, send = false) => {
        if(!isNaN(event.target.value)) {
            setCreature({...creature, armor_class: event.target.value});
            if(send) {
                socket.emit('creatureArmorClassChange', creature.armor_class, creature.creatureGuid, "dm");
                handleCreatureChange()
            }
        }
    }

    const handleHighlight = (e) => {
        e.target.select();
    };

    // Shakes if the user clicks a creature with a statblock in the first position - or removes the last to add the new one
    const handleClick = (index) => {
        handleRemoveFromSelectedIndex(index, true); // Remove last column
        if(selectedIndex.length > 0 && selectedIndex[0].index === index) {
            setShake(index)
        }
    };

    const alertOnClick = (c) => {
        if(c.dnd_b_player_id && c.dnd_b_player_id[0] !== '!') {
            let string = ` -- Trying to Update '${c.name}' Imported DnDBeyond Creature -- \n\nYour changes will reset on auto update\nTo turn OFF auto updates for this Player \n ------------------------ \n1. Click the Color/Alignment button (flag) \n2. Uncheck 'DB Sync'\n\nThis will disable DmBuddy Playerview updating when your player updates their character through DnD Beyond`
            alert(string)
        }
    }

    let isDead = creature.hit_points_current <= 0
    let isBloodied = creature.hit_points_current/creature.hit_points < .55
    let color = "rgb(62, 172, 74)"
    if(isDead) {
        color = "grey"
    } else if(isBloodied) {
        // if 0-.25 then red, if .25-.55 then orange
        color = .25 < creature.hit_points_current/creature.hit_points ? "orange" : "red"
    }

    let hpStyle = {color: color, borderColor: color}
    let effectsCount = effects.length > 0 ? `x${effects.length}` : ''
    let teamColor = COLOR_GREEN
    if (alignment === "enemy") teamColor = COLOR_RED
    else if (alignment === "neutral") teamColor = '#999999'

    let invis = currentEncounter.hideAll;
    // If hideAll === true then dont check anything else
    if(creature.type !== "player" && !invis) {
        if(creature.alignment === "ally" || creature.alignment === "pet") {
            invis = hidden
        } else {
            invis = hidden || currentEncounter.hideEnemies;
        }
    }

    // Only one animation is allowed so switch it if needs to shake
    let animation = shake !== index ? {animation: isTurn ? 'shadowPulseTurn 2s ease-in-out infinite' : ''} : {}
    
    let groupStylesLi = {}
    let groupStylesDiv = {}
    
    if(creature.groupGuid && creature.groupGuid[0] !== '!') {
        let guid = creature.groupGuid;
        let length = currentEncounter.creatures.length
        
        // Check first or last in local group, when checking other groupIds
        let isFirst = index === 0 || (currentEncounter.creatures[index-1]?.groupGuid) !== guid
        let isLast = index+1 === length || (currentEncounter.creatures[index+1]?.groupGuid) !== guid

        groupStylesLi.margin = isFirst ? "3px 0 0 0" : "0 0 0 0"

        groupStylesLi.borderTop = isFirst ? "2px solid rgb(175, 175, 175)" : "none"
        groupStylesLi.borderBottom = isLast ? "2px solid rgb(175, 175, 175)" : "none"
        groupStylesLi.borderRight = `3px solid ${teamColor}`
        // Groups dont lose inset shadow when hovered for group clarity
        let shadow = ''
        if(isFirst && isLast) shadow = 'inset 0px 0px 6px 0px #434343'
        else if(isFirst) shadow = 'inset 0 9px 9px -7px #434343'
        else if(isLast) shadow = 'inset 0 -9px 9px -7px #434343'
        else shadow = 'inset 0px 0px 0px 0px #434343'

        groupStylesDiv.boxShadow = shadow
    }

    let plusDexScore = 
        creature.dexterity === null 
            ? 0 
            : Math.floor((creature.dexterity-10)/2)+(creature.initExtraBonus || 0)

    if(creature.proficiencies && creature.proficiencies['initiative']) {
        plusDexScore += creature.prof_bonus
    }

    return (
            <li 
                key={creature.creatureGuid}
                className={`listItem ${shake === index ? "alreadySelected" : ""}`}
                onClick={() => handleClick(index)}
                style={{
                    // Do not use shorthand on these because they could change ^^ which causes a warning
                    borderTop: isTurn && '2px solid rgba(0, 122, 130)',
                    borderBottom: isTurn && '2px solid rgba(0, 122, 130)',
                    borderRight: isTurn && '2px solid rgba(0, 122, 130)',
                    borderLeft: isTurn && '2px solid rgba(0, 122, 130)',
                    ...animation,
                    opacity: invis ? '.5' : '.90',
                    ...groupStylesLi
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                ref={scrollRef}
            >   
                <div 
                    className={`encounterCreatureContainer animated-box${moveDirection === 'up' ? ' slide-up' : moveDirection === 'down' ? ' slide-down' : ''}`}
                    style={{
                        backgroundImage: `linear-gradient(25deg, ${borderColor} 25%, ${isHovered ? `#bfbba6` : `#cfc9a8`} 50%)`,
                        backgroundSize: '200% 200%',
                        backgroundPosition: isHovered ? '10% 10%':'30% 30%',
                        boxShadow: `${isHovered ? 'inset 0px 0px 0px 0px #434343' : 'inset 0px 0px 6px 0px #434343'}`,
                        transition: 'background-position .5s, box-shadow 0.15s ease',
                        ...groupStylesDiv
                    }} 
                >
                    <div className='encounterCreatureLeftContainer' >
                        <div className='initiativeInputContainer'>
                            <input style={{borderLeft: `6px solid ${teamColor}`}} className='initiativeInput' onFocus={handleHighlight} onBlur={handleInitiativeCheck} type='text' value={creature.initiative} onChange={handleInitiativeChange} onClick={(event) => event.stopPropagation()}/>
                            <div className='initiativeModToken'>{addSign(plusDexScore)}</div>
                        </div>
                        <EditAvatar handleUploadMonsterImage={handleUploadMonsterImage} creature={creature} quickEdit={quickEdit} column={"encounter"}/>
                        <div className='listItemMiddleStats'>
                            <div className='nameInputContainer'>
                                
                                {quickEdit ? 
                                    <input className='nameInput' type='text' style={{fontStyle: 'italic'}} value={creature.name} onChange={handleChangeName} onBlur={(e) => handleChangeName(e, true)} onClick={(event) => event.stopPropagation()}/> 
                                : 
                                    <div className='nameDiv' style={{
                                        borderBottom: isPlayer ? "3px solid white" : "",
                                        borderLeft: isPlayer ? "2px solid white" : "",
                                        borderRight: isPlayer ? "2px solid white" : "",
                                    }}> {creature.name} </div>
                                }
                                
                                {selected && <div className='selectedIndicater siListItem' style={{backgroundColor: colors[selectedPlace]}}>{selectedPlace+1}</div>}

                            </div>
                            <div className='middleStatsContainer'>
                                <EncounterListItemSmallStat label="AC" creature={creature} quickEdit={quickEdit} onChange={handleArmorClassChange} cKey="armor_class"/>
                                {creature.type === "player" &&
                                    <>
                                        <EncounterListItemSmallStat label="Perception" creature={creature} quickEdit={quickEdit} onChange={handleArmorClassChange} showLabel={false}/>
                                        <EncounterListItemSmallStat label="Investigation" creature={creature} quickEdit={quickEdit} onChange={handleArmorClassChange} showLabel={false}/>
                                        <EncounterListItemSmallStat label="Insight" creature={creature} quickEdit={quickEdit} onChange={handleArmorClassChange} showLabel={false}/>
                                        {creature.spellcasting.length > 0 && 
                                            <EncounterListItemSmallStat label="Spell Save DC" creature={creature} quickEdit={quickEdit} onChange={handleArmorClassChange} showLabel={false}/>
                                        }
                                    </>
                                }
                                {moveDirection !== null &&
                                    <svg width="16" height="16" viewBox="0 0 16 16" style={{
                                            verticalAlign: "middle",
                                            transform: moveDirection === "up" ? "rotate(180deg)" : "rotate(0deg)",
                                            minWidth: "16px",
                                            minHeight: "16px"
                                        }}>
                                        <polyline points="4,6 8,10 12,6" fill="none" stroke={moveDirection === "up" ? "#2e552dff" : "#ce0c0cff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                }
                            </div>
                        </div>
                    </div>

                    <div className='listItemOptions'>
                        <div className='optionHide'>
                            <WidgetPopUp 
                                onOpenChange={handleTeamChangeWidget} 
                                trigger={
                                    <FlagPole flagColor={borderColor} teamColor={teamColor} isWidgetOpen={openTeamWidget} />
                                }
                                popUp={
                                    <TeamWidgetPopup borderColor={borderColor} handleTeamColorChange={handleTeamColorChange} handleAlignmentChange={handleAlignmentChange} isPlayer={isPlayer} handleCheckboxChange={handleCheckboxChange} isPet={isPet} handlePetCheckboxChange={handlePetCheckboxChange} showGroup={showGroup} handleGroupCheckboxChange={handleGroupCheckboxChange} isDndB={isDndB} handleDndBCheckboxChange={handleDndBCheckboxChange} alignment={alignment}/>
                                }
                                popOverClass={'editTeamContainer'}
                                alignOffset={-4}
                                sideOffset={8}
                            />
                        </div>
                        <div className={`eyeball ${hidden ? '' : 'optionHide'}`}>
                            <OptionButton src={hidden ? eyeClosed : eyeOpen}  message={(hidden ? "Hidden" : "Visible")} onClickFunction={handleHideEnemy} imgClassName={'option-no-margin'} />
                        </div>
                        <div>
                            <button className='encounterCreatureX optionHide' onClick={(event) => clickEncounterCreatureX(event, creature, index)}>
                            ❌
                            </button>
                        </div>
                        <div className={effects.length === 0 ? 'optionHide' : ''}>
                            <WidgetPopUp 
                                trigger={
                                    <div style={{position: "relative"}}>
                                        {effectsCount &&
                                            <div className='effectsCounter'>{effectsCount}</div>
                                        }
                                        <OptionButton src={EffectImg} message={`Effects ${effectsCount}`} imgStyle={{margin: 0, animation: effectsCount ? 'shadowPulse 4s ease-in-out infinite' : ''}}/>
                                    </div>
                                }
                                popUp={
                                    <EffectGrids creature={creature} creatureListItem={creatureListItem} effects={effects} setEffects={setEffects} currentEncounter={currentEncounter} effectDuration={effectDuration} setEffectDuration={setEffectDuration} conditionDuration={conditionDuration} setConditionDuration={setConditionDuration} socket={socket}/>
                                }
                                popOverClass={'editTeamContainer'}
                                alignOffset={-4}
                                sideOffset={8}
                            />
                        </div>
                    </div>
                    {maxHp !== null ? 
                        <WidgetPopUp 
                            triggerClass={'hpButtonTrigger'}
                            trigger={
                                <div className='encounterCreaturesHpContainer' onClick={() => alertOnClick(creature)} style={{
                                            borderRight: `4px solid ${teamColor}` 
                                        }}>
                                    <button 
                                        className='encounterCreaturesHp'
                                        style={{
                                            backgroundImage: `linear-gradient(to top, ${hpStyle.color} -50%, white 45%)`,
                                            ...hpStyle,
                                        }}
                                    >
                                        {currentHp}
                                        <span>/</span>
                                        {maxHp}
                                        {creature.hit_points_temp !== 0 && (
                                            <span className='tempHp'> (+{creature.hit_points_temp}) </span>
                                        )}
                                    </button>
                                    {creature.type === "player" ? 
                                        <OptionButton src={isPlayerImg} message={'Player Token'} wrapperClassName={'hpButtonPlayerOverlay'} imgStyle={{margin: 0}} onClickFunction={()=> {}}/>
                                    :
                                        <>
                                            {creature.alignment === "pet" && 
                                                <OptionButton src={isPetImg} message={'Pet Token'} wrapperClassName={'hpButtonPlayerOverlay'} imgStyle={{margin: 0}} onClickFunction={()=> {}}/>
                                            }
                                        </>
                                    }
                                    
                                </div>
                            }
                            popUp={
                                <HpEditPopup creature={creature} setCreature={setCreature} currentEncounter={currentEncounter} hpHist={hpHist} setHpHist={setHpHist} handleCreatureChange={handleCreatureChange} setMaxHp={setMaxHp} setCurrentHp={setCurrentHp} socket={socket}/>
                            }
                            popOverClassContainer={'hpPopover'}
                            side='left'
                            sideOffset={25}
                            alignOffset={-15}
                        />
                    :
                        <div className='encounterCreaturesHp'/>
                    }
                </div>
            </li>
           
  );
}

export default EncounterListItem;